import React, { Component } from "react";
import "./App.css";
import "typeface-roboto";
import "bootstrap/dist/css/bootstrap.min.css";

class App extends Component {
  render() {
    return (
      <div class="container">
        <div class="text-center">
          <img
            class="mt-3 mb-1"
            src="https://benjmann.net/static/media/portrait.f5785386.png"
          />

          <h1>
            <strong>Ben Mann</strong>
          </h1>
          <h2>
            <small>Software engineer, tinkerer, aspiring mad scientist</small>
          </h2>

          <div>
            <a class="button" href="https://www.linkedin.com/in/benjamin-mann">
              🍪LinkedIn
            </a>
            • <a href="https://medium.com/@8enmann">🤖Medium</a> •
            <a href="https://benjmann.substack.com/welcome">💓Subscribe</a>
          </div>
        </div>

        <hr />

        <blockquote class="blockquote">
          <p class="mb-0">
            "Any sufficiently advanced technology is indistinguishable from
            magic."
          </p>
          <footer class="blockquote-footer">Arthur C. Clarke</footer>
        </blockquote>
        <p>
          After 6 years of software engineering at Google I left to start a
          company. Then I read Superintelligence and decided to switch focus to
          AI safety, so I went to OpenAI and MIRI, and eventually co-founded
          Anthropic.
        </p>
        <p>
          My mission is to ensure transformative AI has a positive impact on
          humanity's long term future. As of 2023 I am leading product
          engineering at Anthropic, where we're trying to create{" "}
          <a href="https://www.nytimes.com/2023/07/11/technology/anthropic-ai-claude-chatbot.html">
            a safety race
          </a>
          .
        </p>
        <p>
          <a href="https://80000hours.org/">You can help!</a> Do it for the{" "}
          <a href="https://replacingguilt.com/">right reasons</a>.
        </p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js